import { mapProvidersShortOffer, mapTariffs } from "Commons/Components/FormComponents/misc/Mappers";

const getProvider = (data, providerId) => data?.find(({ company }) => company.externalId === providerId);

const convertToProvidersOptions = (providersWithTariffs) => {
  if (!providersWithTariffs || typeof providersWithTariffs !== "object") return [];
  const defaultProvider = extractDefaultProvider(providersWithTariffs);
  const providers = [...defaultProvider, ...providersWithTariffs];
  return providers.map(mapProvidersShortOffer) || [];
};

const extractDefaultProvider = (providersWithTariffs) => {
  if (typeof providersWithTariffs !== "object") return null;
  return (providersWithTariffs || [])
    .filter((provider) => provider.isBasicProvider)
    .map((provider) => ({
      ...provider,
      company: {
        ...provider.company,
        companyName: `${provider.company.companyName} (Standardanbieter)`,
      },
    }));
};

const convertToTariffsOptions = (providersAndTariffs, providerId) => {
  if (!providerId) return [];
  const selectedProvider = getProvider(providersAndTariffs, providerId) || [];
  const providerAllTarrifs = selectedProvider?.tariffs?.product || [];
  const providerDefaultTariffs = extractDefaultTariff(selectedProvider) || [];
  const tariffs = [...providerDefaultTariffs, ...providerAllTarrifs.filter((tariff) => !tariff.isBasicTariff)] || [];
  const dropdownTariffs = tariffs.map(mapTariffs) || [];
  return dropdownTariffs;
};

const extractDefaultTariff = (provider) => {
  return (
    provider?.tariffs?.product
      .filter((tariff) => tariff.isBasicTariff)
      .map((tariff) => ({
        ...tariff,
        name: {
          ...tariff.name,
          text: `${tariff.name.text} (Standardtarif)`,
        },
      })) || []
  );
};

const getCategoryId = (providersAndTariffs, providerId) => {
  if (!providerId) return "";
  const provider = getProvider(providersAndTariffs, providerId);
  return provider?.category?.id;
};

const getCompanyName = (providersAndTariffs, providerId) => {
  if (!providerId) return "";
  const provider = getProvider(providersAndTariffs, providerId);
  return provider?.company?.companyName;
};

const getTariffName = (providersAndTariffs, providerId, tariffFieldValue) => {
  if (!providerId) return "";
  const provider = getProvider(providersAndTariffs, providerId);
  const tariff = provider?.tariffs?.product?.find((tariff) => tariff.id === tariffFieldValue);
  return tariff?.name?.text;
};

const getCategoryPermanentTariffId = (providersAndTariffs, providerId, tariffFieldValue) => {
  if (!providerId) return "";
  const provider = getProvider(providersAndTariffs, providerId);
  const tariff = provider?.tariffs?.product?.find((tariff) => tariff.id === tariffFieldValue);
  return tariff?.permanentId;
};

const getCategoryProviderId = (providersAndTariffs, providerId) => {
  if (!providerId) return "";
  const provider = getProvider(providersAndTariffs, providerId);
  return provider?.id;
};

export {
  getProvider,
  convertToProvidersOptions,
  convertToTariffsOptions,
  getCategoryId,
  getCompanyName,
  getTariffName,
  getCategoryProviderId,
  getCategoryPermanentTariffId,
  extractDefaultProvider,
  extractDefaultTariff,
};
